import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import Change_Logo from './Change_Logo'
import Company_details from './Company_details'
import User_control from './User_control'
import Loglist from './Loglist'
import CompanyTerms from './CompanyTerms'
import Projectlink from './Projectlink'
import Change_pass from './Change_pass'
import $ from 'jquery'

export default function Company_settings() {

    const [selectedEditOption, setSelectedEditOption] = useState('logoupdate');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {

    });

    function offOnEditOption(id) {
        setSelectedEditOption(id);
    }
    function navigatetosubscription() {
        let com_id = localStorage.getItem('mem_company_id');
        window.open("subscription.php?com=" + com_id, "_blank", "noopener,noreferrer");
    }

    function navigatetoPaymentHistory() {
        let com_id = localStorage.getItem('mem_company_id');
        window.open("paymenthistory.php?com=" + com_id, "_blank", "noopener,noreferrer");
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='fullwidth'>
                    <div className='vl_dsh_one_row flex_row'>
                        <div className='flex_div'>
                            <ul className='setting_list'>
                                <li onClick={() => { offOnEditOption('logoupdate') }}>Change Logo</li>
                                <li onClick={() => { offOnEditOption('changepass') }}>Change Password</li>
                                <li onClick={() => { offOnEditOption('comdetails') }}>Company Details</li>
                                <li onClick={navigatetosubscription}>Pay Now</li>
                                <li onClick={navigatetoPaymentHistory}>Payment History</li>
                                <li onClick={() => { offOnEditOption('usercontrol') }}>User Control</li>
                                <li onClick={() => { offOnEditOption('projectlink') }}>Project Link List</li>
                                <li onClick={() => { offOnEditOption('loglist') }}>Log List</li>
                                <li onClick={() => { offOnEditOption('company_terms') }}>Company Terms</li>
                            </ul>
                        </div>
                        <div className='vl_dsh_four_fifth_flex'>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'logoupdate' ? 'activDisplay' : ''}`} id="logoupdate">
                                <Change_Logo />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'comdetails' ? 'activDisplay' : ''}`} id="comdetails">
                                <Company_details />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'changepass' ? 'activDisplay' : ''}`} id="changepass">
                                <Change_pass />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'usercontrol' ? 'activDisplay' : ''}`} id="usercontrol">
                                <User_control />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'loglist' ? 'activDisplay' : ''}`} id="loglist">
                                <Loglist />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'company_terms' ? 'activDisplay' : ''}`} id="company_terms">
                                <CompanyTerms />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'projectlink' ? 'activDisplay' : ''}`} id="projectlink">
                                <Projectlink />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}
